var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.item.exclusiveId ? "修改" : "新建" + "敏感因素",
        visible: _vm.visible,
        width: "400px",
        "before-close": _vm.handleCancel
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "demo-form-inline",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "110px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "敏感因素名称", prop: "exclusiveName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入敏感因素名称" },
                model: {
                  value: _vm.form.exclusiveName,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "exclusiveName", $$v)
                  },
                  expression: "form.exclusiveName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "敏感因素类别", prop: "exclusiveTypeId" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择类别" },
                  model: {
                    value: _vm.form.exclusiveTypeId,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "exclusiveTypeId", $$v)
                    },
                    expression: "form.exclusiveTypeId"
                  }
                },
                _vm._l(_vm.exclusveTypeList, function(item) {
                  return _c("el-option", {
                    attrs: { label: item.name, value: item.dataId }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取 消")
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }